import { Autocomplete } from 'components/helpers/AlgoliaSearch/Autocomplete';
import { classnames } from 'tailwindcss-classnames';
import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import SearchResults from 'components/helpers/AlgoliaSearch/SearchResults';
import { LayoutLeftThirdShell } from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import SearchFacets from 'components/helpers/AlgoliaSearch/SearchFacets';
import SearchStats from 'components/helpers/AlgoliaSearch/SearchStats';
import SearchSort from 'components/helpers/AlgoliaSearch/SearchSort';
import { Routes } from '.generated/templates/Project.Routes.model';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import classNames from 'classnames';
import { getEnumValue } from 'lib/util/enum';
import { ThemeOptions } from 'lib/util/theming';
import { IsNetworkSite, IsNmdpConnectSite, IsNmdpSite } from 'lib/util/site-configuration';
import { useScreenBreakpoint } from 'lib/util/useScreenWidth';

export type SearchBoxProps = Routes.Fields.SearchPage & {
  fields: {
    PlaceholderText?: string;
  };
};

const SearchPage = (): JSX.Element => {
  const sitecoreContext = useSitecoreContext();
  const { fields } = sitecoreContext.sitecoreContext.route as unknown as SearchBoxProps;
  const isNmdpSite = IsNmdpSite();
  const isNetworkSite = IsNetworkSite();
  const isNmdpConnectSite = IsNmdpConnectSite();
  const ritn = sitecoreContext.sitecoreContext.RITN;
  const { isMobileScreen } = useScreenBreakpoint();
  const hideSearchSort = ritn || (isNmdpConnectSite && isMobileScreen);
  const Placeholdertext = fields['Search Bar Placeholder Text'].value;
  const noResultshelpText = fields.noResultsHelpText;
  const filters = fields['Allowed Search Types'];
  const dropdownFilters = filters.map((x) => getEnumValue(x).toLowerCase());

  let themeClass: ThemeOptions;

  if (ritn) {
    themeClass = 'theme-white-black';
  } else {
    themeClass = 'theme-white-nrc';
  }

  let searchResults;
  if (ritn) {
    searchResults = (
      <div>
        <SearchResults
          dropdownFilters={dropdownFilters}
          isRitn
          noResultsHelpText={noResultshelpText}
        />
      </div>
    );
  } else if (isNetworkSite || isNmdpSite) {
    searchResults = (
      <div>
        <SearchResults dropdownFilters={dropdownFilters} noResultsHelpText={noResultshelpText} />
      </div>
    );
  } else {
    searchResults = (
      <LayoutLeftThirdShell
        left={<SearchFacets filters={dropdownFilters} />}
        right={
          <SearchResults
            dropdownFilters={dropdownFilters}
            isRitn={false}
            noResultsHelpText={noResultshelpText}
          />
        }
        isSearchPage
      />
    );
  }

  // NOTE: Even though we do not show Search Facets when in RITN mode, we still need
  // to add the widgets onto the page in order to process facet refinements applied by
  // search initialization
  return (
    <LayoutPageSectionShell theme={themeClass}>
      <div className={classnames({ ritn: ritn, 'lg:hidden': isNmdpSite })}>
        <Autocomplete
          detachedMediaQuery="none"
          openOnFocus
          asSearchBox
          placeholder={Placeholdertext}
        />
      </div>

      <div
        className={classnames(
          'flex',
          'flex-col',
          'md:items-center',
          'justify-between',
          'w-full',
          'md:flex-row',
          'mb-2',
          'py-6',
          'md:py-7',
          { searchResultsControl: isNetworkSite || isNmdpSite }
        )}
      >
        <SearchStats isRitn={ritn} noResultsText={noResultshelpText} />
        <div className={classNames('searchResultsSelect')}>{!hideSearchSort && <SearchSort />}</div>
      </div>
      {searchResults}
    </LayoutPageSectionShell>
  );
};
export default SearchPage;
